<page-loader *ngIf="!loaded"></page-loader>
<div
    *ngIf="loaded"
    class="details-top-section"
    [ngClass]="{
        'burning-question-details': voiceType === 'burningQuestions',
    }">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav
                class="app-l-page__breadcrumbs"
                aria-label="Breadcrumb"
                *ngIf="showBreadcrumbs">
                <ul class="breadcrumbs-list">
                    <li>
                        <a
                            class="breadcrumbs-list-item"
                            [routerLink]="[
                                user.userType === 'superadmin'
                                    ? '/admin/series-listing'
                                    : '/app/series',
                            ]"
                            translate
                            aria-label="Go to series list">
                            series.title
                        </a>
                    </li>
                    <li *ngIf="user.userType === 'user' && !isOrgContent">
                        <a
                            class="breadcrumbs-list-item"
                            [routerLink]="['/app/series/audio']"
                            translate
                            aria-label="Go to audio series">
                            series.seriesTypes.audio
                        </a>
                    </li>
                    <li *ngIf="user.userType === 'user' && !isOrgContent">
                        <a
                            class="breadcrumbs-list-item"
                            [routerLink]="['/app/series/voices/' + voiceType]"
                            aria-label="Go to {{
                                'series.voiceSeries.' + voiceType
                            }}">
                            {{ 'series.voiceSeries.' + voiceType | translate }}
                        </a>
                    </li>
                    <li class="breadcrumbs-list-item" *ngIf="isOrgContent">
                        <a
                            [routerLink]="['/app/series/org-series-contents']"
                            translate
                            aria-current="false">
                            {{ organizationOwnContentTitle }}
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        aria-current="page"
                        tabindex="0">
                        {{ currentVoice ? currentVoice['title_' + lang] : '' }}
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-details-banner">
            <div class="series-type-card stories">
                <div class="cover-image-section">
                    <img
                        *ngIf="voiceType === 'burningQuestions'"
                        [defaultImage]="'../../../assets/img/series/voice-bq-default.svg'"
                        [lazyLoad]="
                            currentVoice?.imageUrl
                                ? currentVoice?.imageUrl
                                : '../../../assets/img/series/voice-bq-default.svg'
                        " />
                    <img
                        *ngIf="voiceType === 'stories'"
                        [defaultImage]="'../../../assets/img/series/voice-stories-bg.svg'"
                        [lazyLoad]="
                            currentVoice?.imageUrl
                                ? currentVoice?.imageUrl
                                : '../../../assets/img/series/voice-stories-bg.svg'
                        " />
                </div>
                <div translate="" class="card-content">
                    <!-- <img
                        *ngIf="voiceType === 'burningQuestions'"
                        [defaultImage]="
                            '../../../assets/img/series/voice-bq-default.jpg'
                        "
                        [lazyLoad]="currentVoice.imageUrl" /> -->
                    <div
                        [ngClass]="{
                            'voice-details': voiceType === 'stories',
                        }">
                        {{ currentVoice ? currentVoice['title_' + lang] : '' }}
                        <span>{{
                            currentVoice ? currentVoice['author_' + lang] : ''
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="app-l-details-wrapper" *ngIf="loaded">
    <div class="app-dm-zen-player">
        <div class="app-dm-zen-footer">
            <div class="app-dm-zen-footer__left">
                <div class="app-dm-play-wrapper">
                    <div class="circle pulse"></div>
                    <a
                        class="circle"
                        tabindex="0"
                        aria-label="Play Audio"
                        [ngClass]="{
                            noAudioSelected:
                                !currentVoice?.audioUrl || !isAudioLoaded,
                        }"
                        (click)="onPlay()"
                        (keydown.enter)="onPlay()"
                        (keydown.space)="onPlay()">
                        <svg
                            style="margin: 14px 12px 14px 16px"
                            *ngIf="!playing && isAudioLoaded"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 17 18"
                            fill="none">
                            <path
                                d="M2.3013 18.9312C2.00158 18.9307 1.70717 18.8521 1.44702 18.7033C0.861235 18.3715 0.49707 17.7273 0.49707 17.0279V2.87524C0.49707 2.17395 0.861235 1.53171 1.44702 1.19986C1.71336 1.04683 2.01593 0.968135 2.32309 0.971998C2.63026 0.975862 2.93075 1.06214 3.19316 1.22182L15.2921 8.46214C15.5443 8.6202 15.7521 8.8397 15.8962 9.10005C16.0403 9.3604 16.1159 9.65307 16.1159 9.95061C16.1159 10.2482 16.0403 10.5408 15.8962 10.8012C15.7521 11.0615 15.5443 11.281 15.2921 11.4391L3.1912 18.6814C2.92267 18.8437 2.61509 18.93 2.3013 18.9312Z"
                                fill="white" />
                        </svg>
                        <svg
                            class="pause"
                            style="margin: 12px 11px 12px 13px"
                            *ngIf="playing && isAudioLoaded"
                            width="20"
                            height="20"
                            viewBox="0 0 13 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.18494 0.87085H1.68494C1.28711 0.87085 0.905581 1.02888 0.624277 1.31019C0.342972 1.59149 0.184937 1.97302 0.184937 2.37085V14.3708C0.184937 14.7687 0.342972 15.1502 0.624277 15.4315C0.905581 15.7128 1.28711 15.8708 1.68494 15.8708H3.18494C3.58276 15.8708 3.96429 15.7128 4.2456 15.4315C4.5269 15.1502 4.68494 14.7687 4.68494 14.3708V2.37085C4.68494 1.97302 4.5269 1.59149 4.2456 1.31019C3.96429 1.02888 3.58276 0.87085 3.18494 0.87085ZM10.6849 0.87085H9.18494C8.78711 0.87085 8.40558 1.02888 8.12428 1.31019C7.84297 1.59149 7.68494 1.97302 7.68494 2.37085V14.3708C7.68494 14.7687 7.84297 15.1502 8.12428 15.4315C8.40558 15.7128 8.78711 15.8708 9.18494 15.8708H10.6849C11.0828 15.8708 11.4643 15.7128 11.7456 15.4315C12.0269 15.1502 12.1849 14.7687 12.1849 14.3708V2.37085C12.1849 1.97302 12.0269 1.59149 11.7456 1.31019C11.4643 1.02888 11.0828 0.87085 10.6849 0.87085Z"
                                fill="white" />
                        </svg>
                        <img
                            *ngIf="!isAudioLoaded"
                            alt="Loading"
                            src="/assets/img/loader.gif"
                            class="loader-gif-xs" />
                    </a>
                </div>
                <div class="current-playing-card-content">
                    <div class="title">
                        {{ currentVoice ? currentVoice['title_' + lang] : '' }}
                    </div>
                    <div class="title-name">
                        {{
                            currentVoice
                                ? ('series.by' | translate) +
                                  currentVoice['author_' + lang]
                                : ''
                        }}
                    </div>
                    <vg-player
                        class="audio-player audio-player-v2"
                        (onPlayerReady)="onPlayerReady($event)">
                        <vg-controls class="player-controls">
                            <vg-scrub-bar
                                class="scrub-bar"
                                vgFor="audio-player"
                                [vgSlider]="false">
                                <vg-scrub-bar-current-time
                                    class="meditation-progress-bar"
                                    id="progress-bar"
                                    [vgSlider]="
                                        true
                                    "></vg-scrub-bar-current-time>
                                <vg-scrub-bar-buffering-time
                                    class="buffer-bar"></vg-scrub-bar-buffering-time>
                            </vg-scrub-bar>
                            <div class="display-time" *ngIf="isPlaying">
                                <vg-time-display
                                    class="play-time"
                                    id="play-time"
                                    vgProperty="current"
                                    vgFormat="mm:ss"></vg-time-display>
                                <vg-time-display
                                    class="total-time"
                                    id="total-time"
                                    vgProperty="total"
                                    vgFormat="mm:ss"></vg-time-display>
                            </div>
                            <div class="display-time-none" *ngIf="!isPlaying">
                                <label
                                    class="play-time"
                                    id="play-time"
                                    vgProperty="current"
                                    vgFormat="mm:ss"
                                    >00:00</label
                                >
                                <label
                                    class="total-time"
                                    id="total-time"
                                    vgProperty="total"
                                    vgFormat="mm:ss"
                                    >00:00</label
                                >
                            </div>
                        </vg-controls>
                        <audio
                            #audioPlayer
                            #media
                            [vgMedia]="media"
                            id="audio-player"
                            preload="auto"
                            type="audio/mp3"
                            volume="0">
                            <source
                                id="audio-source"
                                [src]="currentVoice?.audioUrl"
                                [type]="'audio/mp3'" />
                        </audio>
                    </vg-player>
                </div>
            </div>
            <div class="app-dm-zen-footer__right">
                <div class="app-dm-right-radial-gradient">
                    <p class="playing-title-h1" translate>series.volume</p>
                    <div class="app-c-slider-wrapper">
                        <input
                            type="range"
                            class="app-c-slider app-c-slider--volume"
                            min="0"
                            max="100"
                            step="1"
                            [(ngModel)]="voiceVolume"
                            (ngModelChange)="voiceVolumeChange($event)"
                            (input)="
                                updateVolumeBackground($event.target.value)
                            "
                            [style.background]="volumeTrackBackground" />
                    </div>

                    <span class="playing-title-span">{{ voiceVolume }}%</span>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>

    <div class="app-l-details-content-wrapper">
        <div class="app-l-heading" translate>series.transcript</div>
        <div [innerHtml]="displayText"></div>
        <a
            tabindex="0"
            href="javascript:void(0);"
            (click)="transcriptExpanded = !transcriptExpanded"
            [translate]="
                transcriptExpanded ? 'series.readLess' : 'series.readMore'
            "></a>
        <div class="app-seperator"></div>
        <div class="app-l-vd__f-rate" *ngIf="user.userType === 'user'">
            <h4
                [translate]="
                    voiceType == 'stories'
                        ? 'series.rateStoryTitle'
                        : 'series.rateBQTitle'
                "></h4>
            <!-- <a
                *accessControl="'favorites'"
                class="fav-items"
                aria-label="favorites"
                (click)="setFavourite(video)"
                (keypress)="setFavourite(video)"
                ><img
                    class="icon"
                    alt="favoritesimage"
                    [src]="
                        video.isFavorite
                            ? '/assets/img/icons/icon_fav_filled.svg'
                            : '/assets/img/icons/icon_fav_outline.svg'
                    "
            /></a> -->
            <div class="app-l-vd__rate-wrap">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-16"
                    [attr.aria-label]="'Rate Video ' + star + ' star'"
                    [attr.aria-pressed]="i < selectedStarIndex"
                    *ngFor="let star of [1, 2, 3, 4, 5]; let i = index"
                    [class.active]="i < selectedStarIndex"
                    (click)="rateVoice(i + 1)"
                    (keypress)="rateVoice(i + 1)">
                    <svg-icon
                        icon="star-fill"
                        class="w-100 h-100"
                        alt="star-fill"></svg-icon>
                    <!-- Unicode character for a star -->
                </button>
            </div>
        </div>
    </div>
</div>
<div
    class="voice-series-main-container"
    *ngIf="loaded && user?.userType !== 'superadmin'">
    <div class="series-type-section">
        <div class="app-l-sub-title-holder">
            <span
                class="app-l-subTitle"
                [translate]="
                    voiceType == 'stories'
                        ? 'series.suggestedStories'
                        : 'series.suggestedBurningQuestions'
                "></span>
        </div>
        <div class="series-type-list">
            <ng-container *ngFor="let voice of voiceList">
                <div
                    class="series-type-card type-allen"
                    [ngClass]="{
                        'current-playing': voice.id == currentVoice.id,
                    }"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="
                        (voice.id == currentVoice.id
                            ? 'Currently Playing'
                            : 'Play story ') +
                        (voice ? voice['title_' + lang] : '') +
                        ' by ' +
                        (voice ? voice['author_' + lang] : '')
                    "
                    (click)="changeVoiceSeries(voice)"
                    (keydown.enter)="changeVoiceSeries(voice)"
                    (keydown.space)="changeVoiceSeries(voice)"
                    *ngIf="voiceType == 'stories'">
                    <div class="cover-image-section default-bg">
                        <img
                            [defaultImage]="'../../../assets/img/series/voice-stories-bg.svg'"
                            [lazyLoad]="voice.imageUrl"
                            alt="{{
                                voice
                                    ? voice['title_' + lang]
                                    : 'Story cover image'
                            }}" />
                    </div>

                    <div class="card-content" translate>
                        {{ voice ? voice['title_' + lang] : '' }}
                        <span>{{ voice ? voice['author_' + lang] : '' }}</span>
                    </div>
                </div>
                <div
                    class="app-l-burning-questions-holder"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="
                        (voice.id == currentVoice.id
                            ? 'Currently Playing'
                            : 'Play burning question ') +
                        (voice ? voice['title_' + lang] : '')
                    "
                    (click)="changeVoiceSeries(voice)"
                    (keydown.enter)="changeVoiceSeries(voice)"
                    (keydown.space)="changeVoiceSeries(voice)"
                    *ngIf="voiceType == 'burningQuestions'">
                    <div
                        class="app-l-burning-questions-holder_items"
                        [ngClass]="{
                            'current-playing': voice.id == currentVoice.id,
                        }">
                        <div class="app-l_container">
                            <div class="app-l-content">
                                <span>{{
                                    voice ? voice['title_' + lang] : ''
                                }}</span>
                                <img
                                    class="bg-img"
                                    [defaultImage]="'../../../assets/img/series/voice-bq-default.svg'"
                                    [lazyLoad]="voice.imageUrl"
                                    alt="{{
                                        voice
                                            ? voice['title_' + lang]
                                            : 'Burning question cover image'
                                    }}" />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
